import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import OrdersЕxecutionActions from "../../../components/User/OrdersЕxecutionComponents/OrdersЕxecutionActions";
import OrdersЕxecutionTable from "../../../components/User/OrdersЕxecutionComponents/OrdersЕxecutionTable";

const { getRestaurants } = appActions;

const OrdersЕxecution = () => {
  const { selectedOrganization } = useProjectState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <div>
      <PageHeader text="Справка изпълнение на поръчки" date={true} />
      <OrdersЕxecutionActions />
      <OrdersЕxecutionTable />
    </div>
  );
};

export default OrdersЕxecution;
